import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import FormField from './form-field';
import ButtonIcon from './button-icon';

import TaxonomyClassification from './sub-components/taxonomy-classification';

const TaxonomyTree = ({
	classifications,
	handleClassificationClick,
	selectedClassification = null,
}) => {
	const [expanded, setExpanded] = useState(true);
	const [data, setData] = useState(classifications);
	const [searchString, setSearchString] = useState('');

	const filterData = (nodes, filter) => nodes.reduce(
		(acc, node) => {
			const children = filterData(node.children, filter);

			return acc.concat(
				filter(node) ? { ...node, children } : children,
			);
		},
		[],
	);

	const sortData = array => {
		array.sort((a, b) => a.children?.length - b.children?.length).reverse();
		array.forEach(a => {
			if (a.children && a.children.length > 0) {
				sortData(a.children);
			}
		});
		return array;
	};

	const filterTaxonomy = () => {
		const stringLowerCase = searchString.toLowerCase();
		let filteredClassificationData = filterData(
			classifications, node => node.label.toLowerCase().includes(stringLowerCase),
		);
		filteredClassificationData = sortData(filteredClassificationData);
		setExpanded(false);
		setData(filteredClassificationData);
	};

	useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			if (searchString !== '') {
				filterTaxonomy();
			} else {
				setExpanded(true);
				setData(classifications);
			}
		}, 1500);

		return () => clearTimeout(delayDebounceFn);
	}, [searchString]);

	return (
		<div className="taxonomy-tree">
			<div className="taxonomy-tree__search-container margin-bottom-4">
				<div>
					<FormField
						type="search"
						placeholder="Search"
						action={e => { setSearchString(e.target.value); }}
						id="search_field"
						name="search_field"
						value={searchString}
						fullWidth
					/>
				</div>
				<div className="text-right padding-top-2">
					<ButtonIcon
						icon={expanded ? 'minus' : 'plus'}
						label={expanded ? 'Collapse All' : 'Expand All'}
						iconRight
						onClick={() => setExpanded(!expanded)}
					/>
				</div>
			</div>
			{data?.length > 0 ? (
				data.map((classification, index) => (
					<TaxonomyClassification
						// eslint-disable-next-line react/no-array-index-key
						key={index}
						classification={classification}
						handleClassificationClick={handleClassificationClick}
						expanded={expanded}
						selectedClassification={selectedClassification}
					/>
				))
			) : (
				<p className="grey-text text-center margin-vertical-24">No taxonomy classifications found</p>
			)}
		</div>
	);
};

export default TaxonomyTree;

TaxonomyTree.propTypes = {
	classifications: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string.isRequired,
		id: PropTypes.number.isRequired,
	})).isRequired,
	selectedClassification: PropTypes.number,
	handleClassificationClick: PropTypes.func.isRequired,
};
